// Client mirror of functions-common/src/charts/limits.ts. Keep in sync.

export const CHART_SPEC_MAX_JSON_CHARS = 16000
export const CHART_MAX_TITLE_CHARS = 80
export const CHART_MAX_SUBTITLE_CHARS = 160
export const CHART_MAX_STRING_ID_CHARS = 128
export const CHART_MAX_FILTERS = 20
export const CHART_MAX_FILTER_IN_ITEMS = 50
export const CHART_MAX_COLORS = 12
export const CHART_MAX_SERIES_COLOR_KEYS = 12
export const CHART_MAX_AXIS_LABEL_CHARS = 40
export const CHART_MIN_TOP_N = 1
export const CHART_MAX_TOP_N = 12
export const CHART_MAX_SERIES_PER_CHART = 12
export const CHART_MAX_COMBO_SERIES_PER_MEASURE = 6
export const CHART_MAX_POINTS_PER_SERIES = 500
export const CHART_MAX_RELATIVE_DAYS = 366
export const CHART_MAX_RELATIVE_WEEKS = 104
export const CHART_MAX_RELATIVE_MONTHS = 36

export const CHART_KEY_UNASSIGNED = '__unassigned'
export const CHART_KEY_OTHER = '__other'
export const CHART_LABEL_KEY_UNASSIGNED = 'NLSChartSeriesUnassigned'
export const CHART_LABEL_KEY_OTHER = 'NLSChartSeriesOther'
